const func = require( './function.js' );

$(function(){

	// ブレークポイント
	var breakpoint = window.matchMedia( 'screen and (max-width: 896px)' );

	//ポップアップクローズボタン押下
	$( '.popup__close' ).on( 'click', function() {
		$( '.popup' ).remove();
	});

	//固定ヘッダー対策
	$( window ).scroll( function() {
		if ( ! breakpoint.matches ) {
			var scroll = $( this ).scrollTop();
			var view_height = $( window ).height();
			if ( scroll > view_height / 2 ) {
				$( '.popup' ).slideDown();
			} else {
				$( '.popup' ).slideUp();
			}
		}
	});

	// 入力チェック（売上）
	$( '.sidebar-form [name="gross_profit_coefficient_id"]' ).change( function() {
		var form = $( this ).parents( 'form' );
		var selectWrap = $( this ).parent( '.sidebar-form__selectWrap' );
		selectWrap.removeClass( 'is-valid is-invalid' );

		if ( ! $( this ).val() ) {
			selectWrap.addClass( 'is-invalid' );
		} else {
			selectWrap.addClass( 'is-valid' );
		}
		borderBlink( form );
		formCheck( form );
	});

	// 入力チェック（営業利益）
	$( '.sidebar-form [name="operating_profit"]' ).change( function() {
		var form = $( this ).parents( 'form' );
		var selectWrap = $( this ).parent( '.sidebar-form__selectWrap' );
		selectWrap.removeClass( 'is-valid is-invalid' );

		if ( ! $( this ).val() ) {
			selectWrap.addClass( 'is-invalid' );
		} else {
			selectWrap.addClass( 'is-valid' );
		}
		form.find( '[name="operating_profit_million"]' ).val( $( this ).find( 'option:selected' ).attr( 'data-key' ) );
		borderBlink( form );
		formCheck( form );
	});

	// 入力チェック（純資産）
	$( '.sidebar-form [name="net_worth"]' ).change( function() {
		var form = $( this ).parents( 'form' );
		var selectWrap = $( this ).parent( '.sidebar-form__selectWrap' );
		selectWrap.removeClass( 'is-valid is-invalid' );

		if ( ! $( this ).val() ) {
			selectWrap.addClass( 'is-invalid' );
		} else {
			selectWrap.addClass( 'is-valid' );
		}
		form.find( '[name="net_worth_million"]' ).val( $( this ).find( 'option:selected' ).attr( 'data-key' ) );
		borderBlink( form );
		formCheck( form );
	});

	// 入力チェック（電話番号）
	$( '.sidebar-form [name="tel"]' ).blur( function() {
		var form = $( this ).parents( 'form' );
		var inputWrap = $( this ).parent( '.sidebar-form__inputWrap' );
		inputWrap.removeClass( 'is-valid is-invalid' );
		inputWrap.next( '.sidebar-form__error' ).remove();

		if ( ! $( this ).val() ) {
			inputWrap.addClass( 'is-invalid' );
		} else if ( ! func.is_mobile_tel( $( this ).val() ) ) {
			inputWrap.addClass( 'is-invalid' );
			inputWrap.after( '<p class="sidebar-form__error">携帯番号の形式が正しくありません。</p>' );
		} else {
			inputWrap.addClass( 'is-valid' );
		}
		borderBlink( form );
		formCheck( form );
	});

	// 入力チェック（メールアドレス）
	$( '.sidebar-form [name="mail_address"]' ).blur( function() {
		var form = $( this ).parents( 'form' );
		var inputWrap = $( this ).parents( '.sidebar-form__inputWrap' );
		inputWrap.removeClass( 'is-valid is-invalid' );
		inputWrap.next( '.sidebar-form__error' ).remove();

		if ( ! $( this ).val() ) {
			inputWrap.addClass( 'is-valid' );
		} else if ( ! func.is_email( $( this ).val() ) ) {
			inputWrap.addClass( 'is-invalid' );
			inputWrap.after( '<p class="sidebar-form__error">メールアドレスの形式ではありません。</p>' );
		} else {
			inputWrap.addClass( 'is-valid' );
		}
		borderBlink( form );
		formCheck( form );
	});

	function borderBlink( form ) {
		form.find( '.sidebar-form__itemField' ).removeClass( 'is-active' );
		form.find( '.sidebar-form__item' ).each( function() {
			if ( ! $( this ).find( '.sidebar-form__selectWrap, .sidebar-form__inputWrap' ).hasClass( 'is-valid' ) ) {
				$( this ).find( '.sidebar-form__itemField' ).addClass( 'is-active' );
				return false;
			}
		});
	}

	// 入力フォームチェック
	function formCheck( form ) {
		var grossProfitCoefficientId = form.find( '[name="gross_profit_coefficient_id"]' );
		var operatingProfit = form.find( '[name="operating_profit"]' );
		var netWorth = form.find( '[name="net_worth"]' );
		var tel = form.find( '[name="tel"]' );
		var mailAddress = form.find( '[name="mail_address"]' );

		if ( grossProfitCoefficientId.val() && operatingProfit.val() && netWorth.val() ) {
			form.find( '.sidebar-form__item--tel' ).slideDown();
			if ( func.is_mobile_tel( tel.val() ) ) {
				form.find( '.sidebar-form__item--mail' ).slideDown();
			}
		}
		if ( grossProfitCoefficientId.val() && operatingProfit.val() && netWorth.val() && func.is_mobile_tel( tel.val() ) && ( func.is_email( mailAddress.val() ) || mailAddress.val() == '' ) ) {
			form.find( '.sidebar-form__submit' ).prop( 'disabled', false );
		} else {
			form.find( '.sidebar-form__submit' ).prop( 'disabled', true );
		}
	}
});
	



//////////////////
// WEBPACK FOOTER
// ./assets/javascripts/base.js
// module id = 2
// module chunks = 0